export default {
  props: {
    windowId: {
      type: String,
      required: true
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/window-id.js